import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { FileDown, QrCode } from "lucide-react";
import { QRCodeSVG } from "qrcode.react";

export default function AdminQrPosterPage() {
  const { t, lang } = useI18n();
  const [config, setConfig] = useState({ center_code: "MAIN-OFFICE", wall_qr_payload: "TUITION://MAIN-OFFICE" });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/config/public").then((r) => setConfig(r.data)).catch(() => {});
  }, []);

  const downloadPdf = async () => {
    setBusy(true);
    try {
      const res = await api.get("/config/qr-poster.pdf", { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
      const a = document.createElement("a");
      a.href = url;
      a.download = "wall-qr-poster.pdf";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      toast.error(lang === "ms" ? "Gagal memuat turun poster" : "Failed to download poster");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-6" data-testid="admin-qr-poster">
      <div>
        <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">{t("wallQR")}</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          {lang === "ms"
            ? "Cetak poster QR ini dan lekatkan di dinding pejabat. Ibu bapa akan mengimbasnya untuk daftar masuk anak."
            : "Print this QR poster and stick it on the office wall. Parents will scan it to check their children in."}
        </p>
      </div>

      <div className="grid gap-6 md:grid-cols-2">
        <Card className="rounded-2xl">
          <CardContent className="p-6 text-center">
            <h2 className="font-display text-lg font-bold flex items-center justify-center gap-2">
              <QrCode className="h-5 w-5 text-primary" /> {t("wallQR")}
            </h2>
            <div className="mt-4 grid place-items-center">
              <div className="rounded-2xl bg-white p-5 shadow-sm">
                <QRCodeSVG
                  value={config.wall_qr_payload || `TUITION://${config.center_code}`}
                  size={240}
                  bgColor="#ffffff"
                  fgColor="#0A5C36"
                />
              </div>
            </div>
            <p className="mt-3 num text-xs text-muted-foreground">Center code: {config.center_code}</p>
          </CardContent>
        </Card>

        <Card className="rounded-2xl">
          <CardContent className="p-6">
            <h2 className="font-display text-lg font-bold">{lang === "ms" ? "Cetak poster (PDF)" : "Print poster (PDF)"}</h2>
            <p className="mt-2 text-sm text-muted-foreground">
              {lang === "ms"
                ? "Muat turun poster A4 sedia cetak dengan QR besar, arahan dwibahasa dan kod pusat."
                : "Download a print-ready A4 poster with a large QR, bilingual instructions and the center code."}
            </p>
            <Button
              onClick={downloadPdf}
              disabled={busy}
              className="mt-4 h-11 rounded-full gap-2"
              data-testid="download-poster-btn"
            >
              <FileDown className="h-4 w-4" /> {lang === "ms" ? "Muat turun PDF" : "Download PDF"}
            </Button>
            <ul className="mt-6 space-y-2 text-sm text-muted-foreground">
              <li>• {lang === "ms" ? "Hanya admin boleh melihat & mencetak poster ini." : "Only admins can view & print this poster."}</li>
              <li>• {lang === "ms" ? "Ibu bapa membuka aplikasi, pilih anak dan imbas QR ini." : "Parents open the app, pick a child and scan this QR."}</li>
            </ul>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
